import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CmsLink } from '@/models';

@Component({
  name: 'CmgUnsupportedBrowserHeader',
})
export default class CmgUnsupportedBrowserHeader extends Vue { 

  get logoImageUrl(): string {
    return this.$appStore.state.cms.images.logos.medallion.default;
  }

  get links(): CmsLink[] {
    return this.$appStore.state.cms.header.links;
  }
}
